export default __webpack_public_path__ + "media/images/landing-22-550x420-ed7ed0c55e06b0e1fdb3c2cc9fa27cbd.jpg";